export {default} from '../hashtag/Hashtag';



// WEBPACK FOOTER //
// ./src/components/async/Hashtag.js